module.exports = __webpack_public_path__ + "static/media/arrow-right.28c55b0e.svg";